import _ from 'lodash';
import EventBus from '../../../EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  data() {
    return {
      previousState:         null,
      pageWiseUndoRedoArray: [{
        list: [],
      }],
      pageWiseUndoRedoIndexArray: [{
        activeStep: 0,
      }],
    };
  },
  mounted() {
    EventBus.$on('changeUndoRedoRestButtonOnPageChange', this.changeUndoRedoResetButtonStatus);
    EventBus.$on('updatePageWiseUndoRedoArray', this.updatePageWiseUndoRedoArray);
  },
  destroyed() {
    EventBus.$off('changeUndoRedoRestButtonOnPageChange', this.changeUndoRedoResetButtonStatus);
    EventBus.$off('updatePageWiseUndoRedoArray', this.updatePageWiseUndoRedoArray);
  },
  methods: {
    updatePageWiseUndoRedoArray(newIndex, oldIndex) {
      if (oldIndex < 0 || oldIndex >= this.pageWiseUndoRedoArray.length
          || newIndex < 0 || newIndex >= this.pageWiseUndoRedoArray.length) {
        console.error('Invalid index provided');
        return;
      }

      const objToMoveArray = this.pageWiseUndoRedoArray.splice(oldIndex, 1)[0];
      this.pageWiseUndoRedoArray.splice(newIndex, 0, objToMoveArray);

      const objToMoveIndex = this.pageWiseUndoRedoIndexArray.splice(oldIndex, 1)[0];
      this.pageWiseUndoRedoIndexArray.splice(newIndex, 0, objToMoveIndex);
    },
    resetSpecificUndoRedoArray() {
      this.pageWiseUndoRedoArray[this.activePage].list            = [this.pageWiseUndoRedoArray[this.activePage].list[0]];
      this.pageWiseUndoRedoIndexArray[this.activePage].activeStep = 0;
      this.applyUndoRedoOnProduct(this.pageWiseUndoRedoArray[this.activePage].list[0]);
      this.changeUndoRedoResetButtonStatus();
      setTimeout(() => {
        EventBus.$emit('ReplaceHighResResources');
      }, 0);

      this.pageWiseUndoRedoArray[this.activePage].list && (this.$store.commit('setUndoRedoArrayListLength', this.pageWiseUndoRedoArray[this.activePage].list.length));
    },
    deletePageDataFromPageWiseUndoRedoArray() {
      this.pageWiseUndoRedoArray.splice(this.activePage, 1);
      this.pageWiseUndoRedoIndexArray.splice(this.activePage, 1);
    },
    duplicatePageInPageWiseUndoRedo() {
      this.pageWiseUndoRedoArray.push({ list: this.pageWiseUndoRedoArray[this.activePage].list });
      this.pageWiseUndoRedoIndexArray.push({ activeStep: this.pageWiseUndoRedoIndexArray[this.activePage].activeStep });
    },
    addNewPageInPageWiseUndoRedo() {
      this.pageWiseUndoRedoArray.push({ list: [this.resetSomeKeysToIgnore(_.cloneDeep(this.product.pages[this.product.pages.length - 1]))] });
      this.pageWiseUndoRedoIndexArray.push({ activeStep: 0 });
    },
    initiatePageWiseUndoRedoArray() {
      this.previousState              = null;
      this.pageWiseUndoRedoArray      = [{
        list: [this.resetSomeKeysToIgnore(_.cloneDeep(this.product.pages[0]))],
      }];
      this.pageWiseUndoRedoIndexArray = [{
        activeStep: 0,
      }];
      for (let i = 1; i < this.product.pages.length; i++) {
        this.pageWiseUndoRedoArray.push({ list: [this.resetSomeKeysToIgnore(_.cloneDeep(this.product.pages[i]))] });
        this.pageWiseUndoRedoIndexArray.push({ activeStep: 0 });
      }
      this.changeUndoRedoResetButtonStatus();
    },
    onAddIntoPageWiseUndoRedoArray(calledBy) {
      console.log('From:', calledBy);
      // const tempList = Object.assign([], this.product.pages[this.activePage].objectList);
      const tempList          = this.resetSomeKeysToIgnore(_.cloneDeep(this.product.pages[this.activePage]));
      const lastUndoRedoEntry = this.pageWiseUndoRedoArray[this.activePage].list[this.pageWiseUndoRedoIndexArray[this.activePage].activeStep];
      this.pageWiseUndoRedoArray[this.activePage].list && (this.$store.commit('setUndoRedoArrayListLength', this.pageWiseUndoRedoArray[this.activePage].list.length));
      // check if last undo redo array's index data is not equal to current data
      if (JSON.stringify(lastUndoRedoEntry) !== JSON.stringify(tempList)) {
        if (this.pageWiseUndoRedoArray[this.activePage].list.length > 1500) {
          this.pageWiseUndoRedoArray[this.activePage].list.splice(1500, this.pageWiseUndoRedoArray[this.activePage].list.length);
        }
        // if undo redo pointer is less not on last entry on any new change
        if (this.pageWiseUndoRedoIndexArray[this.activePage].activeStep < this.pageWiseUndoRedoArray[this.activePage].list.length - 1) {
          this.pageWiseUndoRedoArray[this.activePage].list.splice(this.pageWiseUndoRedoIndexArray[this.activePage].activeStep + 1, this.pageWiseUndoRedoArray[this.activePage].list.length - 1);
        }
        // adding new data to undo redo
        this.pageWiseUndoRedoArray[this.activePage].list.push(tempList);
        // setting undo redo pointer to the last of the list
        this.pageWiseUndoRedoIndexArray[this.activePage].activeStep = this.pageWiseUndoRedoArray[this.activePage].list.length - 1;
        // assigning value to the previous state
        // this.previousState = JSON.stringify(tempList);
        this.changeUndoRedoResetButtonStatus();
        // }
        // }
      } else {
        console.log('No changes detected');
      }
    },
    changeUndoRedoResetButtonStatus() {
      if (this.pageWiseUndoRedoArray[this.activePage].list.length > 1) {
        EventBus.$emit('setValueForUndoRedoReset', false);
      } else {
        EventBus.$emit('setValueForUndoRedoReset', true);
      }
    },
    resetSomeKeysToIgnore(tempList) {
      tempList.objectList.forEach((object) => {
        object.isSelected     = false;
        object.editor         = null;
        object.isEditorEnable = false;
        if (object.type === 'text') {
          object.Value                              = object.modifiedHtml;
          object.valuesForLeftPanel.fontFamily      = 'none';
          object.valuesForLeftPanel.fontSize        = 16;
          object.valuesForLeftPanel.lineSpacing     = 0;
          object.valuesForLeftPanel.color           = 'black';
          object.valuesForLeftPanel.isBold          = false;
          object.valuesForLeftPanel.isItalic        = false;
          object.valuesForLeftPanel.isUnderline     = false;
          object.valuesForLeftPanel.isJustifyCenter = false;
          object.valuesForLeftPanel.isJustifyLeft   = true;
          object.valuesForLeftPanel.isJustifyRight  = false;
          object.valuesForLeftPanel.verticalAlign   = 'Middle';
          object.valuesForLeftPanel.isJustify       = false;
          object.valuesForLeftPanel.isBulletList    = false;
          object.valuesForLeftPanel.isNumberList    = false;
          object.valuesForLeftPanel.isSubScript     = false;
          object.valuesForLeftPanel.isSupperScript  = false;
        }
      });
      return tempList;
    },
    onUpdateProductByPageWiseUndoRedo(action) {
      const changeInPointer = {
        undo: -1,
        redo: 1,
      };

      if (action === 'undo' && this.pageWiseUndoRedoIndexArray[this.activePage].activeStep < 1) {
        return;
      }
      if (action === 'redo' && this.pageWiseUndoRedoIndexArray[this.activePage].activeStep > this.pageWiseUndoRedoArray[this.activePage].list.length - 2) {
        return;
      }
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
      this.$store.commit('activeProduct/updateShowVideoPanel', false);
      this.$store.commit('activeProduct/setIsAnimationInProgress', false);

      this.$store.commit('activeProduct/updateDisplayAnimationPanel', false);
      this.pageWiseUndoRedoIndexArray[this.activePage].activeStep += changeInPointer[action];
      this.applyUndoRedoOnProduct(this.pageWiseUndoRedoArray[this.activePage].list[this.pageWiseUndoRedoIndexArray[this.activePage].activeStep]);
      this.pageWiseUndoRedoArray[this.activePage].list && (this.$store.commit('setUndoRedoArrayListLength', this.pageWiseUndoRedoArray[this.activePage].list.length));
    },
    applyUndoRedoOnProduct(data) {
      this.product.pages[this.activePage] = JSON.parse(JSON.stringify(data));
      const tempProduct                   = JSON.parse(JSON.stringify(this.product));
      this.product                        = null;
      this.product                        = tempProduct;
      this.deSelectActiveObject();
    },
  },

};
